/* eslint-disable no-unused-vars */
/* eslint-disable one-var */
/* eslint-disable semi */
/* eslint-disable quotes */
/* eslint-disable space-before-function-paren */
/* eslint-disable indent */

var swipeEnabled = true

function initSwipeEvents(element) {
  var touchDown = false,
    originalPosition = null,
    lastMouseX = 0,
    twoFingers = false,
    swipeLeft = false,
    swipeRight = false

  function swipeInfo(event) {
    if (originalPosition === null) {
      return
    }

    var x = event.clientX,
      dx

    if (x === undefined || x === null) {
      x = event.touches[0].clientX
    }

    dx = (x > originalPosition.x) ? "right" : "left"

    return {
      direction: {
        x: dx
      },
      offset: {
        x: x - originalPosition.x
      }
    }
  }

  element.addEventListener('touchstart', function(e) {
    touchDown = true
    originalPosition = {
      x: e.touches[0].clientX
    }
    twoFingers = e.touches.length > 1
  }, { passive: false })

  element.addEventListener('touchend', function(e) {
    touchDown = false
    originalPosition = null
    lastMouseX = 0
    if (swipeLeft) {
      dispatchCustomEvent('swipeToNextPage')
      swipeLeft = false
    }
    if (swipeRight) {
      dispatchCustomEvent('swipeToPrevPage')
      swipeRight = false
    }
  })

  element.addEventListener('touchcancel', function(e) {
    touchDown = false
    originalPosition = null
  }, { passive: false })

  element.addEventListener('touchmove', function(e) {
    var info = swipeInfo(e)
    if (!twoFingers) {
      twoFingers = e.touches.length > 1
    }

    if (!touchDown || twoFingers) {
      return
    }

    swipeLeft = false
    swipeRight = false

    var distance = 0
    if (info.direction.x === 'left') {
      distance = lastMouseX - info.offset.x
    } else if (info.direction.x === 'right') {
      distance = info.offset.x - lastMouseX
    }

    lastMouseX = info.offset.x

    var pageElement = element
    var pageWidth = 0
    if (pageElement !== null) {
      pageWidth = parseInt(pageElement.offsetWidth, 10)
    }

    // How do we define a swipe? If the distance of the touch (measured from touch start to touch end) is > 20px
    // And we move the finger with speed of more than 5px
    var boundingRect = pageElement.getBoundingClientRect()
    let scale = boundingRect.width / pageWidth
    var touchSpeed = Math.abs(info.offset.x)
    var isAndroid = /(android)/i.test(navigator.userAgent)
    if (isAndroid) {
      scale = 3
    }
    var canSwipe = (distance > 10 * scale && touchSpeed > 5 * scale) && swipeEnabled

    // If not all of the page is visible within the window.
    // This is usually for spread pages on mobile devices with a width less than 500px.
    if (pageWidth > window.innerWidth) {
      var absoluteX = Math.abs(boundingRect.left)
      var absoluteDiff = pageWidth - window.innerWidth

      // We ask to swipe to previuos page only if the page is scrolled completely to the left.
      // We ask to swipe to next page only if the page is scrolled completely to the right.
      if (boundingRect.left > -2 && canSwipe && info.direction.x === 'right') {
        // dispatchCustomEvent('swipeToPrevPage')
        swipeRight = true
      } else if (absoluteX > absoluteDiff - 2 && canSwipe && info.direction.x === 'left') {
        // dispatchCustomEvent('swipeToNextPage')
        swipeLeft = true
      }
    } else {
      // The page is visible within the window.
      if (canSwipe) {
        if (info.direction.x === 'right') {
          swipeRight = true
          // dispatchCustomEvent('swipeToPrevPage')
        } else if (info.direction.x === 'left') {
          swipeLeft = true
          // dispatchCustomEvent('swipeToNextPage')
        }
      }
    }
  }, { passive: false })
  return true
}

function dispatchCustomEvent(eventName) {
  var pagesContainer = document.getElementById('pages-container')
  var newEvent = document.createEvent('Event')
  newEvent.initEvent(eventName, true, true)

  pagesContainer.dispatchEvent(newEvent)
}

function enableSwiping() {
  swipeEnabled = true
}

function disableSwiping() {
  swipeEnabled = false
}

export {
  initSwipeEvents,
  enableSwiping,
  disableSwiping
}
